import { Flex, ListItem, Text } from "@chakra-ui/react"
import {
  isFriday,
  isMonday,
  isSaturday,
  isSunday,
  isThursday,
  isTuesday,
  isWednesday,
} from "date-fns"
import React from "react"
import { useTranslation } from "react-i18next"
import { RemoteStoreHours, StoreHourDay } from "./RemoteStoreTypes"

interface Props {
  day: StoreHourDay
  storeHours: RemoteStoreHours[]
}

const isThisDayToday = (day: StoreHourDay) => {
  const today = new Date()

  switch (day) {
    case "monday":
      return isMonday(today)
    case "tuesday":
      return isTuesday(today)
    case "wednesday":
      return isWednesday(today)
    case "thursday":
      return isThursday(today)
    case "friday":
      return isFriday(today)
    case "saturday":
      return isSaturday(today)
    case "sunday":
      return isSunday(today)
    default:
      return false
  }
}

const formatTimeToAmPm = (time: string) => {
  const [hours, minutes] = time.split(":").map(Number)
  const period = hours >= 12 ? "pm" : "am"
  const adjustedHours = hours % 12 || 12 // Convert 0 to 12 for midnight

  return `${adjustedHours}.${String(minutes).padStart(2, "0")} ${period}`
}

const StoreHourRow: React.FC<Props> = ({ storeHours = [], day }) => {
  const { t } = useTranslation()

  const row = storeHours.find(storeHour => storeHour.day === day)

  if (!row) {
    return null
  }

  const { open, close } = row

  const shouldHighlight = isThisDayToday(day)
  const hasHours = Boolean(open) && Boolean(close)
  const hourLabel = hasHours
    ? `${formatTimeToAmPm(open)} - ${formatTimeToAmPm(close)}`
    : t("components.store.StoreHours.closed")

  return (
    <ListItem>
      <Flex justifyContent="space-between">
        <Text fontWeight={shouldHighlight ? "bold" : "normal"} fontSize="small">
          {t(`components.store-search.StoreHourRow.days.${day}`)}
        </Text>
        <Text fontWeight={shouldHighlight ? "bold" : "normal"} fontSize="small">
          {hourLabel}
        </Text>
      </Flex>
    </ListItem>
  )
}

export default StoreHourRow
